module.exports = __webpack_public_path__ + "media/smiles/dissapointed_2-026d8d43.svg";